import React from "react";

export function About() {
    return (
      <main>
        <section className="about">
          <h1>About Me</h1>
          <p>
            I am a seasoned professional with extensive expertise in AI, Machine Learning, Cloud Computing, and Data Engineering.
          </p>
          <ul>
            <li><strong>AI & Machine Learning:</strong> Predictive analytics and intelligent automation.</li>
            <li><strong>Cloud Computing:</strong> Scalable cloud solutions using AWS services.</li>
            <li><strong>Data Analytics & Engineering:</strong> Data wrangling, visualization, and RAG-based AI architectures.</li>
          </ul>
        </section>
      </main>
    );
  }